import { Component, Input } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { JobPostingInterviewMultipleChoiceTypes } from '../../enums/job-posting-interview-multiple-choice-types.enum';

@Component({
    selector: 'app-job-posting-interview-multiple-choice-preview',
    templateUrl: './job-posting-interview-multiple-choice-preview.html',
})
export class JobPostingInterviewMultipleChoicePreviewComponent {
    @Input() interviewQuestion: InterviewQuestion;
    @Input('aria-labelledby') ariaLabelledBy?: string;
    jobPostingInterviewMultipleChoiceTypes = JobPostingInterviewMultipleChoiceTypes;
}
